import React from "react";
import {Button, Container, Modal, Row, Table} from "react-bootstrap";
import {X} from "react-feather";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSearch,faInfoCircle} from "@fortawesome/free-solid-svg-icons";
//import ReportAnnotatorComponent from "../Annotator/ReportAnnotatorComponent";




function ReportAnnotatorModalComponent(props) {
    let [modalShow, setModalShow] = React.useState(false);

    const lvTextStyle = {
    whiteSpace: 'pre-line',
    textAlign: 'left',
    height: 925
};

    /*const scrollTotheAnnotation = (id) => {
        if (document.getElementById(id) !== null) {
            alert(id)
            let mark = document.getElementById(id);
            mark.scrollIntoView({block: 'start', behavior: 'smooth'});
        }
    }*/

    function ShowReportAnnotatorModal(props) {

        return (
            <Modal
                {...props}
                //size="l"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                //size="m"
                /*style={{maxWidth: "100%",
                        width: "auto",
                        display: "inline-block"}}*/
                animation={false}
                /*onEntering={function(){
                    alert(props.dataid)
                    scrollTotheAnnotation(props.dataid)
                }}*/
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Leistungsbeschreibung
                    </Modal.Title>
                </Modal.Header>
               <Modal.Body>
                    {/*<>
            <ReportAnnotatorComponent
                lvreportDisplay={true}
                lvComponentShow={true}
                annotationComponentShow={true}
                annotatorFooterShow={false}
                adviceList={[]}
                lvList={props.modalData.lvInfo.lvInfo.data}
                annotationData={props.modalData.annotationData}
                lvCustomerView={true}
                annotationCustomerView={true}
                suggestComponentShow={false}
                positionCategoryShow={false}
                highlightPossible={false}
                searchComponentShow={false}
                deleteComponentShow={false}
                summaryComponentShow={false}
                saveComponentShow={false}
                publishComponentShow={false}
                editAdviceComponentShow={false}
                ignoreComponentShow={false}
                categoryComponentShow={false}
                createAdviceComponentShow={false}
            />
        </>*/}

                   <div style={{height: 925}}>
            <div className="handwai-dark div-border handwai-text-label-normal add-10-padding"
                 style={lvTextStyle}>
                <Row className="div-bottom-border addMarginMinus10">
                </Row>
                <br/>
                <Container fluid>
                    <div className="lv-div-scroll" style={{height: 850}}>
                        <Table striped bordered hover variant="dark">
                            <thead>
                            <tr>
                                <th>Leistungsbeschreibung</th>
                            </tr>
                            </thead>
                            <tbody>{props.modalData}</tbody>
                        </Table>
                    </div>
                </Container>
            </div>

        </div>






                </Modal.Body>
                <Modal.Footer>
                   <Button size="lg" variant="outline-dark" onClick={props.onHide}> <X/> &nbsp;
                        Abbrechen
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }


    return (


            <><div style={{display:"flex"}}>
                <Button className={"handwai-btn-report"}
                disabled={props.data.shortText==="nan"}
            onClick={()=>
            {
                let baseURL = "https://www.google.com/search?q="
                window.open(baseURL + props.data.googleText, 'googletext')}
            }
            ><FontAwesomeIcon icon={faSearch}/> Suchen</Button>
                    {' '}

            <Button style={{marginLeft:"10px"}}className={"handwai-btn-report"} onClick={() => {
                setModalShow(true)
            }}><FontAwesomeIcon icon={faInfoCircle}/> Info</Button>
</div>

            <ShowReportAnnotatorModal
                //lvid={lvid}
                show={modalShow}
                onHide={() => setModalShow(false)}
                modalData={props.modalData}
                dataid={props.data.unique_id}
            />

        </>



    );
}

export default ReportAnnotatorModalComponent;
